import { classNames, ids } from 'constants/elementIdentifiers'

export const getBadNetworkSelector = id =>
    `#${ids.TILE_PREFIX}${id} .${classNames.BAD_NETWORK_CONTAINER}`
